
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class FactCompositeConstituentDialog extends SiteEntityDialog<FactCompositeConstituentRow, any> {
        protected getFormKey() { return FactCompositeConstituentForm.formKey; }
        protected getIdProperty() { return FactCompositeConstituentRow.idProperty; }
        protected getLocalTextPrefix() { return FactCompositeConstituentRow.localTextPrefix; }
        protected getService() { return FactCompositeConstituentService.baseUrl; }
        protected getDeletePermission() { return FactCompositeConstituentRow.deletePermission; }
        protected getInsertPermission() { return FactCompositeConstituentRow.insertPermission; }
        protected getUpdatePermission() { return FactCompositeConstituentRow.updatePermission; }

        protected form = new FactCompositeConstituentForm(this.idPrefix);

    }
}